import React, { useMemo } from 'react';

import { useUserDetailsContext } from 'context/userDetailsContext';
import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';

import ViewChanger from './ViewChanger';
import constants from 'constants/index';
import Discrepancy from './Discrepancy';
import CreateTimeline from './CreateTimeline';
import CreateDocument from './CreateDocument';
import ExtractEntities from './ExtractEntities';
import UploadFileButton from './UploadFileButton';
import CreateFolderButton from './CreateFolderButton';
import DownloadCaseButton from './DownloadCaseButton';

function Menu() {
  const { getPermission, checkSubPermission } = useUserDetailsContext();
  const { isGlobalFileManager, isCaseFileManager, isLeadFileManager, isClientFileManager, isFirmDocuments, breadCrumbs } =
    useFileManagerContext();

  const canWrite = getPermission('cases') === constants.permissions.WRITE;
  const showDiscrepancy = checkSubPermission('ai_find_discrepancies') && (isCaseFileManager || isLeadFileManager);
  const showCreateDocument = checkSubPermission('document_assembly') && !isGlobalFileManager && !isClientFileManager;
  const showCreateFolder = isFirmDocuments || (!isGlobalFileManager && !isClientFileManager);
  const showUpload = isCaseFileManager || isClientFileManager || isLeadFileManager;
  const showExtractEntities = checkSubPermission('ai_extract_entities') && !isGlobalFileManager && !isClientFileManager;
  const showTimeline = checkSubPermission('ai_create_timeline') && !isGlobalFileManager && !isClientFileManager;
  const showDownloadCase = isCaseFileManager || isLeadFileManager;

  const isVirtualFolder = useMemo(() => breadCrumbs?.some((file) => file?.is_virtual === true), [breadCrumbs]);

  return (
    <div className="menu-row d-flex gap-2 flex-wrap align-items-center">
      <ViewChanger />
      {showDiscrepancy ? <Discrepancy /> : null}
      {showCreateDocument && <CreateDocument />}
      {(canWrite || isClientFileManager) && !isVirtualFolder && showCreateFolder && <CreateFolderButton />}
      {(canWrite || isClientFileManager) && !isVirtualFolder && showUpload && <UploadFileButton />}
      {(canWrite || isClientFileManager) && !isVirtualFolder && showDownloadCase && <DownloadCaseButton />}
      {showExtractEntities && <ExtractEntities />}
      {showTimeline && <CreateTimeline />}
    </div>
  );
}

export default Menu;
